<div> <pdf-viewer
              [src]="pdfsrc"
              [rotation]="0"    
              [fit-to-page]="true"
              [original-size]="true"
              [show-all]="true"
              [zoom]="1.5"
              style="display: block; width: 100%;">
  </pdf-viewer>
</div>
